import { isUtilityEdition } from '@/helpers/Edition';
import appInfoUtility from './app_info.utility.json';
import appInfoOlivine from './app_info.olivine.json';

export default isUtilityEdition ? appInfoUtility : appInfoOlivine;
